import React from "react";

// import navigation data
import { navigation } from "../data";

// import Link
import { Link } from "react-scroll";
import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";

const Nav = () => {
  const { Theme } = useContext(ThemeContext)
  return (
    <nav>
      <ul className="flex space-x-8 capitalize text-[15px]">
        {navigation.map((item, idx) => {
          return (
            <li
              className={`${Theme === "dark" ? "hover:text-black-400" : "hover:text-red-400"} cursor-pointer font-semibold `}
              key={idx}
            >
              <Link
                to={item.href}
                activeClass={`-mt-8 cursor-pointer capitalize ${Theme === "dark" ? "text-black-400" : "text-white"} bg-${Theme === "dark" ? "[#F2AA4CFF]" : "red-400"} border-solid `}
                spy={true}
                smooth={true}
                duration={300}
                offset={-70}
                className={`transition-all duration-300 p-3 rounded-full`}
              >
                {item.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
